<template>
  <div class="form-page confirm-field-wrapper">
    <div class="content-left" v-if="history[currentStep].name === 'confirm_email'">
      <p style="margin: 0px">{{config.params.for_fields.confirm_email.text_1[0]}}
        <b>{{historyEmail}}</b>{{config.params.for_fields.confirm_email.text_1[1]}}
        <a href="/reg">{{config.params.for_fields.confirm_email.text_1[2]}}</a>.
      </p>
    </div>
<!--    <a class="moneyman-header" v-if="history[currentStep].name === 'confirm' && nextField && nextField.name === 'moneyman_agreements'">-->
<!--      Tiene disponible {{moneymanSum > 300 ? 300 : moneymanSum}} euros a devolver en {{(moneymanPeriod > 30) ? 30 : moneymanPeriod}} días sin intereses-->
<!--    </a>-->
    <div class="tooltip" v-if="history[currentStep].name === 'confirm'">
      <span class="icon icon-info-line"><info-icon/></span>
      <p class="tooltip-text">
        {{config.params.for_fields.phone_verification}}<b class="phone-for-confirm">{{historyPhone}}</b>
      </p>
    </div>
    <!-- one input -->
    <div class="form-input__wrap">
      <input
        v-if="showInput"
        type="tel"
        class="form-input"
        v-model="inputVal"
        :placeholder="history[currentStep].field.placeholder"
        @keyup="handleKeyup"
        @focus="handleFocus"
        :name="history[currentStep].name"
        v-bind:class="{error: history[currentStep].showError && !isValidConfirmOnly || invalidFromBackend}"
        required>
      <span class="form-input-floating-label">{{history[currentStep].field.placeholder}}</span>
    </div>
    <transition name="fade">
      <span class="error-message" v-if="history[currentStep].showError && !isValidConfirmOnly || invalidFromBackend">
        {{history[currentStep].field.error}}
      </span>
    </transition>
    <div v-if="history[currentStep].name === 'confirm_email'" style="margin-top: 10px">
      <div class="content-left">
        <p class="yellow-box">{{config.params.for_fields.confirm_email.text_2[0]}}
          <b>{{config.params.for_fields.confirm_email.text_2[1]}}</b>
          {{config.params.for_fields.confirm_email.text_2[2]}}
          <b>{{config.params.for_fields.confirm_email.text_2[3]}}</b>
          <span v-if="isGmail" class="to_spam_link"> (<b><a href="https://mail.google.com/mail/u/0/#spam" target="_blank" style="color: #ff1b53">¡HAZ CLIC AQUÍ!</a></b>)</span>
        </p>
      </div>
      <div class="content-left">
        <a class="skip-link" @click="skipEmailVerify">{{config.params.for_fields.confirm_email.text_3[0]}}</a>
        {{config.params.for_fields.confirm_email.text_3[1]}}
      </div>
    </div>
    <div v-if="additionalCheckboxes.length">
      <Checkbox
        v-for="(checkbox, index) in additionalCheckboxes"
        :key="index"
        :show-error="!checkbox.checked && checkbox.required && history[currentStep].showError"
        v-model="checkbox.checked"
        @change="updateCheckboxes"
        name="confirm_checkboxes"
      >
        <p v-html="checkbox.label"></p>
      </Checkbox>
<!--      <label v-for="(checkbox, index) in additionalCheckboxes" :key="index" class="form-checkbox__wrap">-->
<!--        <input-->
<!--          @change="updateCheckboxes"-->
<!--          v-model="checkbox.checked"-->
<!--          :class="{error: !checkbox.checked && checkbox.required && history[currentStep].showError}"-->
<!--          name="confirm_checkboxes"-->
<!--          type="checkbox">-->
<!--        <span class="form-checkbox"></span>-->
<!--        <p v-html="checkbox.label"></p>-->
<!--      </label>-->
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import InfoIcon from '../assetComponents/InfoIcon'
import Checkbox from '../assetComponents/Checkbox'
import Crezu from '@/utils/'
let timeout

export default {
  name: 'Confirm',
  components: { InfoIcon, Checkbox },
  data () {
    return {
      inputVal: null,
      initValue: false,
      additionalCheckboxes: [],
      moneymanSum: +localStorage.getItem('loan_sum') || 300,
      moneymanPeriod: +localStorage.getItem('loan_period') || 30
    }
  },
  computed: {
    isValidConfirmOnly () {
      let regex = new RegExp(this.history[this.currentStep].field.reg)
      return regex.test(this.inputVal) && this.inputVal !== '0000'
    },
    isValid () {
      return this.isValidConfirmOnly && this.isValidCheckboxes()
    },
    invalidFromBackend () {
      let result = false
      let values = this.history[this.currentStep].invalidValues
      if (values && values.indexOf(this.inputVal) > -1) result = true
      return result
    },
    supportEmail () {
      return this.config.params.for_fields.confirm_email.support_email.split('@')[0] + '@' + window.location.hostname
    },
    isGmail () {
      return this.historyEmail.indexOf('@gmail.com') > -1
    },
    historyEmail () {
      return this.getHistoryValue('email')
    },
    historyPhone () {
      return this.getHistoryValue('phone')
    },
    ...mapState({
      history: state => state.history,
      currentStep: state => state.currentStep,
      nextField: state => state.history[state.currentStep + 1],
      config: state => state.config,
      showInput: state => state.showInput
    })
  },
  beforeMount () {
    if (this.nextField && this.nextField.name) {
      let nextFieldInfo = this.$store.getters.getFieldInfoByName(this.nextField.name)
      if (nextFieldInfo.data) this.additionalCheckboxes = nextFieldInfo.data
    }

    timeout = setTimeout(() => {
      this.$store.commit('SHOW_SKIP_BUTTON', true)
    }, 20000)
  },
  mounted () {
    // TODO: delete moneyman additional
    this.$store.dispatch('sendCrezuEvent', { id: 24, data: { sub2: 'confirm', sub3: 'confirm_inited' } })

    this.inputVal = this.history[this.currentStep].value
    if (this.nextField && this.nextField.name === 'moneyman_agreements') {
      this.$store.dispatch('initializeJuicyScore')
      this.$store.dispatch('getCustomerToken', 'moneyman_agreements').then((data) => {
        let dataJson = {}
        try {
          dataJson = JSON.parse(data)
          window.paylands_required = dataJson.paylands_required || 0
          window.online_banking_required = dataJson.online_banking_required || 0
        } catch (e) {}
        document.getElementById('moneyman-contract').href = dataJson.contract
      })
    }
  },
  beforeDestroy () {
    clearTimeout(timeout)
  },
  watch: {
    inputVal: function (val) {
      if (!this.initValue) { this.initValue = true; return }
      this.$store.commit('UPDATE_FIELD', { isValid: this.isValid, value: val })
    }
  },
  methods: {
    handleKeyup (e) {
      if (e.keyCode === 13) {
        this.$store.dispatch('nextStepPrepare', +1)
      }
    },
    handleFocus (e) {
      // TODO: delete moneyman additional
      this.$store.dispatch('sendCrezuEvent', { id: 24, data: { sub2: 'confirm', sub3: 'confirm_focused' } })
    },
    skipEmailVerify () {
      this.$cookie.set('has_declined_confirm_email', 1, { expires: '1D' })
      this.$store.commit('UPDATE_FIELD', { isValid: true, value: 'IGNORE', skip: true })
      this.$store.dispatch('nextStepPrepare', +1)
    },
    getHistoryValue (field) {
      for (let h in this.$store.state.history) {
        if (this.$store.state.history[h].name === field) {
          return this.$store.state.history[h].value
        }
      }
      return localStorage.getItem(field) || ''
    },
    isValidCheckboxes () {
      let additional = true
      for (let i in this.additionalCheckboxes) {
        if (this.additionalCheckboxes[i].required && !this.additionalCheckboxes[i].checked) {
          additional = false
        }
      }
      return additional
    },
    updateCheckboxes (e) {
      if (this.isValidCheckboxes() && this.nextField && ['moneyman_agreements', 'prestamer_agreements'].indexOf(this.nextField.name) > -1) {
        if (this.nextField.name === 'moneyman_agreements') {
          let moneymanCheckboxes = {}
          for (let i in this.additionalCheckboxes) {
            moneymanCheckboxes[`moneyman${+i + 1}`] = this.additionalCheckboxes[i].checked
          }
          this.$store.commit('CHANGE_ADDITIONAL_PARAMS', moneymanCheckboxes)
        }
        this.$store.dispatch('insertOrUpdateField', {
          index: this.currentStep + 1,
          data: { name: this.nextField.name, value: 1 }
        })
      }
      this.$store.commit('UPDATE_FIELD', { isValid: this.isValid })
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.content-left {
  text-align: left;
  margin-bottom: 5px;
  font-size: smaller;
}
.skip-link {
  cursor: pointer;
}
b {
  font-weight: bold;
}
  .yellow-box {
    border: 1px solid lightgray;
    padding: 5px;
    background: lightyellow;
  }
  .phone-for-confirm {
    font-weight: 600;
    font-size: 14px;
  }
  .moneyman-header {
    font-size: 16px;
    margin-bottom: 20px;
    font-weight: bold;
    margin-top: -10px;
  }
</style>



// WEBPACK FOOTER //
// src/components/fields/Confirm.vue